import React from "react";

export default function ActionButtons({ setShowNewTaskPopup, handleExportPDF }) {
  return (
    <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
      <button
        onClick={() => setShowNewTaskPopup(true)}
        style={{
          padding: "6px 12px",
          border: "1px solid #e6e9ef",
          borderRadius: 4,
          background: "#00c875",
          color: "#ffffff",
          cursor: "pointer",
          fontSize: 14,
          fontWeight: 500,
        }}
      >
        New Task
      </button>
      <button
        onClick={handleExportPDF}
        style={{
          padding: "6px 12px",
          border: "1px solid #e6e9ef",
          borderRadius: 4,
          background: "#0073ea",
          color: "#ffffff",
          cursor: "pointer",
          fontSize: 14,
          fontWeight: 500,
        }}
      >
        Export PDF
      </button>
    </div>
  );
}

